<template>
    <!-- 홈 통계 기간: 올해 / 연도별(‹ 2026년 ›) / 직접설정(월 단위) — 연도·달력은 칩 아래 줄 — 바꾸면 바로 change({ start, end }) -->
    <div class="hp-filter">
        <div class="hp-row">
            <div class="hp-chips">
                <button v-for="m in MODES" :key="m.key" type="button" class="hp-chip" :class="{ on: mode == m.key }" :aria-pressed="mode == m.key" @click="setMode(m.key)">{{ m.label }}</button>
            </div>
        </div>
        <div v-if="mode == 'year'" class="hp-year" role="group" aria-label="연도 선택">
            <button type="button" aria-label="이전 해" :disabled="year <= YEAR_MIN" @click="stepYear(-1)">‹</button>
            <span>{{ year }}년</span>
            <button type="button" aria-label="다음 해" :disabled="year >= YEAR_MAX" @click="stepYear(1)">›</button>
        </div>
        <div v-show="mode == 'custom'" class="hp-months">
            <Datepicker v-model="pick_start" month-picker :clearable="false" format="yyyy.MM" preview-format="yyyy.MM"
                :minDate="new Date(YEAR_MIN, 0, 1)" :maxDate="new Date()" auto-apply selectText="선택" cancelText="취소"
                @update:model-value="onPick">
                <template #month="{ value }">{{ value + 1 }}월</template>
                <template #month-overlay="{ value }">{{ value + 1 }}월</template>
                <template #month-overlay-value="{ value }">{{ value + 1 }}월</template>
            </Datepicker>
            <span class="hp-dash">~</span>
            <Datepicker v-model="pick_end" month-picker :clearable="false" format="yyyy.MM" preview-format="yyyy.MM"
                :minDate="monthDate(pick_start)" :maxDate="new Date()" auto-apply selectText="선택" cancelText="취소"
                @update:model-value="onPick">
                <template #month="{ value }">{{ value + 1 }}월</template>
                <template #month-overlay="{ value }">{{ value + 1 }}월</template>
                <template #month-overlay-value="{ value }">{{ value + 1 }}월</template>
            </Datepicker>
        </div>
    </div>
</template>

<script>
const moment = require('moment');

const MODES = [{ key: 'this', label: '올해' }, { key: 'year', label: '연도별' }, { key: 'custom', label: '직접설정' }];
const YEAR_MAX = moment().year();
const YEAR_MIN = 2022;   //포인핸드 보호소 프로그램 기록 시작

export default {
    name: 'HomePeriodFilter',
    emits: ['change'],
    data() {
        const now = moment();
        return {
            MODES, YEAR_MIN, YEAR_MAX,
            mode: 'this',
            year: YEAR_MAX,
            pick_start: { month: 0, year: now.year() },
            pick_end: { month: now.month(), year: now.year() },
        };
    },
    methods: {
        monthDate(m) { return m ? new Date(m.year, m.month, 1) : null; },
        //기간 → { start: Date(그 달 1일), end: Date(그 달 말일, 오늘 넘으면 오늘) }
        range() {
            const today = moment().endOf('day');
            let s, e;
            if (this.mode == 'year') { s = moment({ year: this.year, month: 0, day: 1 }); e = s.clone().endOf('year'); }
            else if (this.mode == 'custom') {
                s = moment({ year: this.pick_start.year, month: this.pick_start.month, day: 1 });
                e = moment({ year: this.pick_end.year, month: this.pick_end.month, day: 1 }).endOf('month');
                if (e.isBefore(s)) e = s.clone().endOf('month');
            }
            else { s = moment().startOf('year'); e = today.clone(); }
            if (e.isAfter(today)) e = today.clone();
            return { start: s.toDate(), end: e.toDate() };
        },
        emitChange() { this.$emit('change', this.range()); },
        setMode(m) {
            this.mode = m;
            if (m == 'custom') {
                //직접설정으로 넘어갈 때 지금 보던 기간을 달력에 그대로
                const r = moment(this.range().start), e = moment(this.range().end);
                this.pick_start = { month: r.month(), year: r.year() };
                this.pick_end = { month: e.month(), year: e.year() };
            }
            this.emitChange();
        },
        stepYear(d) {
            const y = this.year + d;
            if (y < YEAR_MIN || y > YEAR_MAX) return;
            this.year = y;
            this.emitChange();
        },
        onPick() {
            //시작 달을 끝 달 뒤로 옮기면 끝 달도 같이
            if (this.monthDate(this.pick_end) < this.monthDate(this.pick_start)) this.pick_end = { ...this.pick_start };
            this.$nextTick(this.emitChange);
        },
    },
};
</script>

<style scoped>
    .hp-filter { display: flex; flex-direction: column; align-items: flex-end; gap: 8px; }
    .hp-row { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; justify-content: flex-end; }
    .hp-chips { display: flex; gap: 6px; }
    .hp-chip { height: 28px; padding: 0 12px; border-radius: 14px; border: 1px solid #dcdcdc; background: #fff; color: #666; font-size: 13px; font-weight: 600; cursor: pointer; }
    .hp-chip:hover { border-color: #F6951C; }
    .hp-chip.on { background: #F6951C; border-color: #F6951C; color: #fff; }
    .hp-chip:focus-visible { outline: 2px solid #F6951C; outline-offset: 2px; }
    .hp-year { display: inline-flex; align-items: center; height: 30px; }
    .hp-year span { min-width: 66px; text-align: center; font-size: 15px; font-weight: 700; color: #222; font-variant-numeric: tabular-nums; }
    .hp-year button { width: 28px; height: 100%; border: 0; background: transparent; font-size: 22px; line-height: 1; color: #444; cursor: pointer; }
    .hp-year button:hover:not(:disabled) { color: #F6951C; }
    .hp-year button:disabled { color: #d0d0d0; cursor: default; }
    .hp-months { display: flex; align-items: center; gap: 4px; }
    .hp-months :deep(.dp__main) { width: 120px; }
    .hp-months :deep(.dp__input) { font-size: 13px; height: 30px; padding-top: 0; padding-bottom: 0; }
    .hp-dash { color: #999; }
    @media (max-width: 768px) {
        .hp-filter { align-items: stretch; width: 100%; }
        .hp-row { justify-content: flex-start; }
        .hp-months :deep(.dp__main) { width: auto; flex: 1 1 0; }
        .hp-months { width: 100%; }
    }
</style>
